/*
 * Copyright (c)  CYBERKOALA LLC 2026.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

import { useMaybeRoomContext } from '@livekit/components-react';
import { useScreenShareSync } from '@/context/call-context/use-screen-share-sync';
import React from 'react';

export const ScreenShareStateBridge: React.FC = () => {
  const room = useMaybeRoomContext();

  useScreenShareSync(room);

  return null;
};
